import React from 'react'
import moment from 'moment'
import momentTimezone from 'moment-timezone'

const Timezone: React.FC<any> = ({ identityTimezone }) => {
  const d = new Date()
  return (
    <div>
      <div>Date – {d.toString()}</div>
      <div>Locale – {d.toLocaleString()}</div>
      <div>Timezone Offset – {d.getTimezoneOffset()}</div>
      <div>UserAgent – {navigator.userAgent}</div>
      <div>Moment Version – {moment.version}</div>
      <div>Moment guess – {moment.tz.guess()}</div>
      <div>Moment guess ignoreCache true – {moment.tz.guess(true)}</div>
      <div>Moment Timezone guess – {momentTimezone.tz.guess()}</div>
      <div>Moment Timezone guess ignoreCache true – {momentTimezone.tz.guess(true)}</div>
      <div>Identity Timezone – {identityTimezone}</div>
    </div>
  )
}

export default Timezone
